/* eslint no-eval: 0 */

import Adobe from "./providers/adobe";
import Facebook from "./providers/facebook";
import FloodlightActivities from "./providers/floodlightActivities";
import { GoogleRMKT, GoogleSiteTag } from "./providers/google";

const pixelDb = {
  triggers: {
    onRoute: {
      simulacion: [
        "Adobe.paso1",
        "Facebook.simulacion",
        "GoogleRMKT.simulacion",
        "GoogleRMKT.enviar",
        "GoogleSiteTag.snippetPaso1",
        "FloodlightActivities.paso1",
      ],
      noCliente: [
        "Adobe.noCliente",
        "Facebook.noCliente",
        "GoogleRMKT.noCliente",
        "GoogleRMKT.enviar",
        "GoogleSiteTag.snippetPaso2",
        "FloodlightActivities.noCliente",
      ],
      cliente: [
        "Adobe.cliente",
        "Facebook.cliente",
        "GoogleRMKT.cliente",
        "GoogleRMKT.enviar",
        "GoogleSiteTag.snippetCliente",
        "FloodlightActivities.cliente",
      ],
      mensaje: ["Adobe.mensaje"],
      datosPersonales: [
        "Adobe.paso2",
        "Facebook.datosPersonales",
        "GoogleRMKT.datosPersonales",
        "GoogleRMKT.enviar",
        "GoogleSiteTag.snippetPaso3",
        "FloodlightActivities.paso3",
      ],
      datosLaborales: [
        "Adobe.paso3",
        "Facebook.datosLaborales",
        "GoogleRMKT.datosLaborales",
        "GoogleRMKT.enviar",
        "GoogleSiteTag.snippetPaso4",
        "FloodlightActivities.paso4",
      ],
      activity: [
        "Adobe.paso4",
        "Facebook.activity",
        "GoogleRMKT.activity",
        "GoogleRMKT.enviar",
        "GoogleSiteTag.snippetPaso5",
        "FloodlightActivities.paso5",
      ],
      datosCuenta: [
        "Adobe.paso5",
        "Facebook.datosCuenta",
        "GoogleRMKT.datosCuenta",
        "GoogleRMKT.enviar",
        "GoogleSiteTag.snippetPaso6",
        "FloodlightActivities.paso6",
      ],
      confirmacion: [
        "Adobe.paso6",
        "Facebook.confirmacion",
        "GoogleRMKT.confirmacion",
        "GoogleRMKT.enviar",
        "GoogleSiteTag.snippetPaso7",
        "FloodlightActivities.paso7",
      ],
      verificando: ["Adobe.paso7"],
      thankyou: [
        "Adobe.gracias",
        "Facebook.thank",
        "GoogleRMKT.thank",
        "GoogleRMKT.enviar",
        "GoogleSiteTag.snippetThank",
        "FloodlightActivities.thank",
      ],
      errorInesperado: ["Adobe.errorInesperado"],
      mensajeInvalido: ["Adobe.mensajeInvalido"],
      pepsosi: ["Adobe.pepsosi"],
    },
    onClickTracking: ["Adobe.appStartedClick"],
    onClickStart: ["Adobe.appOnClickStart"],
  },
  providers: {
    Adobe,
    Facebook,
    GoogleRMKT,
    GoogleSiteTag,
    FloodlightActivities,
  },
};

export default pixelDb;
